import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { CognitoService } from "src/app/shared/services/cognito.service";
import { showError } from "src/app/shared/utils/functions/notification.function";
import { encryptStorage } from "src/app/shared/utils/storage/storage";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
})
export class LoginComponent implements OnInit {
  hasError: boolean = false;

  formLoginUser: FormGroup;

  constructor(private router: Router, private cognitoService: CognitoService) {}

  ngOnInit() {
    this.formLoginUser = new FormGroup({
      document: new FormControl("", [Validators.required]),
      password: new FormControl("", [Validators.required]),
    });
  }

  login() {
    if (this.formLoginUser.valid) {
      this.cognitoService
        .signIn(this.document.value, this.password.value)
        .subscribe(
          (res) => {
            const tipoUsuario = String(
              encryptStorage.getItem("@tipoUsuario")
            ).toUpperCase();

            if (
              tipoUsuario === "LIQUIDANTE" ||
              tipoUsuario === "INTERVENIENTE"
            ) {
              this.router.navigate([`/${res}`]);
            } else {
              showError(
                "",
                "Este portal é exclusivo para os usuários liquidantes e intervenientes."
              );
            }
          },
          (err) => {
            if (err.status == 400 || err.status == 422) {
              showError("", err.error.data.detalhesErro[0]);
            } else {
              showError("", err.message || "Ocorreu uma falha durante a autenticação.");
            }
          }
        );
    }
  }

  lostPassword() {
    this.router.navigate(["/lost-password"]);
  }

  //GET & SETTER
  private get document() {
    return this.formLoginUser.get("document");
  }

  private get password() {
    return this.formLoginUser.get("password");
  }
}
